import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Box, TextField, makeStyles } from '@material-ui/core';
import { COLOR_BORDER, COLOR_MIDDLE_GRAY } from '../../styles/colors';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Input from '../Input';

const useStyles = makeStyles(theme => ({
  textField: {
    minWidth: 220,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLOR_BORDER,
    },
  },
  colorSwatchWrapper: {
      // flex: '0 0 155px',
      minWidth: 120,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    colorSwatchLabel: {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
    },
    colorSwatch: {
      width: 30,
      height: 30,
      borderRadius: 8,
      backgroundColor: '#ee5a46',
      border: `1px solid ${COLOR_BORDER}`,
      marginLeft: theme.spacing(1),
    },
}), { name: 'ColorSwatch' });

function ColorSwatch({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref } }) => (
        <Box className={classes.colorSwatchWrapper}>
          <div className={classes.colorSwatchLabel}>{label}</div>
          <div className={classes.colorSwatch} style={{backgroundColor: value }}/>
        </Box>
        )}
    />
  );
}

export default memo(ColorSwatch);
